const LABEL_GTM = "Google Tag Manager";
const LABEL_MTM = "Matomo Tag Manager";
const PRESET_ID_TAG_MANAGER_REGEXP = /^(gtm|mtm|(gtm-|mtm-).*)$/;
function getManagerDependingVariables(setCookiesViaManager, { presetId, isGcm }) {
    let useGlobalObjectName;
    let getDataLayer;
    let serviceIsManager = false;
    let managerLabel = "";
    let expectedManagerPresetId;
    const features = {
        events: true,
        executeCodeWhenNoTagManagerConsentIsGiven: true
    };
    let useManager = setCookiesViaManager || "none";
    if (useManager === "googleTagManagerWithGcm" && !isGcm) {
        useManager = "googleTagManager";
    }
    switch(useManager){
        case "googleTagManager":
        case "googleTagManagerWithGcm":
            expectedManagerPresetId = "gtm";
            useGlobalObjectName = "dataLayer";
            managerLabel = LABEL_GTM;
            features.events = useManager !== "googleTagManagerWithGcm";
            break;
        case "matomoTagManager":
            expectedManagerPresetId = "mtm";
            useGlobalObjectName = "_mtm";
            managerLabel = LABEL_MTM;
            break;
        default:
            features.events = false;
            features.executeCodeWhenNoTagManagerConsentIsGiven = false;
            break;
    }
    if (useGlobalObjectName) {
        getDataLayer = ()=>{
            window[useGlobalObjectName] = window[useGlobalObjectName] || [];
            return window[useGlobalObjectName];
        };
    }
    if (PRESET_ID_TAG_MANAGER_REGEXP.test(presetId)) {
        serviceIsManager = true;
        features.events = false;
        features.executeCodeWhenNoTagManagerConsentIsGiven = false;
    }
    return {
        getDataLayer,
        useManager,
        serviceIsManager,
        managerLabel,
        expectedManagerPresetId,
        features
    };
}
export { LABEL_GTM, LABEL_MTM, PRESET_ID_TAG_MANAGER_REGEXP, getManagerDependingVariables };
